/**
 * Track event corresponding to `type` and `options`
 *
 * @param {Object} options values used for the consent update
 * @returns {Promise<Object>} execution result
 */
function update(options) {
  const { optOut, location } = options;
  if (typeof optOut !== 'boolean') {
    return Promise.reject(
      new Error('mParticle: Expected optOut to be a boolean.')
    );
  }

  const user = window.mParticle.Identity.getCurrentUser();
  if (!user || typeof user.setConsentState !== 'function') {
    return Promise.reject(
      new Error(
        'mParticle: Expected a user to be available for setting the consent state.'
      )
    );
  }

  try {
    const consentState = window.mParticle.Consent.createConsentState();
    const updatedConsent = window.mParticle.Consent.createCCPAConsent(
      optOut,
      Date.now(),
      'ccpa_agreement_v1',
      location || window.location.toString()
    );
    consentState.setCCPAConsentState(updatedConsent);
    user.setConsentState(consentState);
    return Promise.resolve({ done: true });
  } catch (err) {
    return Promise.reject(
      new Error(`mParticle: Could not update consent. Got error: ${err}.`)
    );
  }
}

module.exports = { update };
